import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'cms-menu',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './menu.html',
  styleUrl: './menu.css'
})
export class Menu {

}
